// Adress ip du serveur node ( Sur le VM )
// export const BASEURL = "https://mobile.exadis.com";
export const BASEURL = "https://api.oscarmygr.fr";
